import { render } from "./BaseClose.vue?vue&type=template&id=df4f6978&scoped=true"
import script from "./BaseClose.vue?vue&type=script&lang=js"
export * from "./BaseClose.vue?vue&type=script&lang=js"

import "./BaseClose.vue?vue&type=style&index=0&id=df4f6978&scoped=true&lang=scss"

import exportComponent from "/Users/petertoh/Sites/martin-keehn/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df4f6978"]])

export default __exports__